import Vue from "vue";
import VueRouter from "vue-router";

import About from "./modules/about";
import Dynamic from "./modules/dynamic";
import SoftWare from "./modules/software";
import Serve from "./modules/serve";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

const routes = [
    {
        path:"/",
        redirect:"/Home",
        component:() => import("@/view/Index"),
        children:[
            {
                name:"Home",
                path:"Home",
                component:() => import("@/view/Home"),
                meta:{
                    title:"首页",
                }
            },
            {
                name:'About',
                path:"About",
                redirect:"/About/Company",
                component:() => import("@/view/About"),
                meta:{
                    title:"关于我们",
                },
                children:[...About]
            },
            {
                name:'SoftWare',
                path:"SoftWare",
                redirect:"/SoftWare/CustomerManage",
                component:() => import("@/view/SoftWare"),
                meta:{
                    title:"软件功能",
                },
                children:[...SoftWare]
            },
            {
                name:'Dynamic',
                path:"Dynamic",
                redirect:"/Dynamic/Allnew",
                component:() => import("@/view/Dynamic"),
                meta:{
                    title:"文章动态",
                },
                children:[...Dynamic]
            },
            {
                name:'Serve',
                path:"Serve",
                redirect:"/Serve/Area",
                component:() => import("@/view/Serve"),
                meta:{
                    title:"服务商",
                },
                children:[...Serve]
            },
           
        ]
    }

]

Vue.use(VueRouter);
const router = new VueRouter ({routes})
//全局后置守卫：初始化时执行、每次路由切换后执行
router.afterEach((to,from)=>{
	if(to.meta.title){ 
		document.title = to.meta.title //修改网页的title
	}else{
		document.title = '企小达'
	}
})

export default router;